/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `mm` - mm
 * * `mm/h` - mm/h
 * @export
 */
export const TimeseriesRainMmUnitsEnum = {
  MM: "mm",
  MM_H: "mm/h",
} as const;
export type TimeseriesRainMmUnitsEnum =
  (typeof TimeseriesRainMmUnitsEnum)[keyof typeof TimeseriesRainMmUnitsEnum];

export function instanceOfTimeseriesRainMmUnitsEnum(value: any): boolean {
  for (const key in TimeseriesRainMmUnitsEnum) {
    if (Object.prototype.hasOwnProperty.call(TimeseriesRainMmUnitsEnum, key)) {
      if (TimeseriesRainMmUnitsEnum[key as keyof typeof TimeseriesRainMmUnitsEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function TimeseriesRainMmUnitsEnumFromJSON(json: any): TimeseriesRainMmUnitsEnum {
  return TimeseriesRainMmUnitsEnumFromJSONTyped(json, false);
}

export function TimeseriesRainMmUnitsEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): TimeseriesRainMmUnitsEnum {
  return json as TimeseriesRainMmUnitsEnum;
}

export function TimeseriesRainMmUnitsEnumToJSON(value?: TimeseriesRainMmUnitsEnum | null): any {
  return value as any;
}

export function TimeseriesRainMmUnitsEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): TimeseriesRainMmUnitsEnum {
  return value as TimeseriesRainMmUnitsEnum;
}
